import { DrawingAppliance, DrawingShape } from '../models';
import {
  ensureMutableArray,
  forceAssignProperty,
} from './objectMutability.utils';

export const removeApplianceFromShape = (
  drawingShape: DrawingShape,
  appliance: DrawingAppliance
) => {
  const applianceIndex = drawingShape.appliances.findIndex(
    (applianceModel) => applianceModel.id === appliance.id
  );

  if (applianceIndex !== -1) {
    const mutableAppliancesArray = ensureMutableArray(drawingShape.appliances);

    if (mutableAppliancesArray !== drawingShape.appliances) {
      forceAssignProperty(drawingShape, 'appliances', mutableAppliancesArray);
    }

    mutableAppliancesArray.splice(applianceIndex, 1);
  }

  return drawingShape;
};
